import React from "react";
import { Field, FastField } from "formik";
import get from "lodash.get";
import DatePicker from "../../../../../../ui/widgets/date";
import { TextInputProps } from "../../../../../../ui/widgets/text-input/types";

interface TextInputWrapperPropsType extends TextInputProps {
  field: {
    name: string;
    value?: string | number;
  };
}

const DatePickerWrapper = ({ field, ...props }: TextInputWrapperPropsType) => {
  const error = get(props, `form.errors.${field.name}`);
  const touched = get(props, `form.touched.${field.name}`);
  return (
    <DatePicker
      shrink={props.shrink ? props.shrink : Boolean(field.value)}
      id={field.name}
      {...field}
      {...props}
      error={!!(error && touched)}
      helperText={touched && error}
    />
  );
};

export default function DatePickerInputField(
  props: TextInputProps,
): React.JSX.Element {
  return props.forceReRender ? (
    <Field component={DatePickerWrapper} {...props} />
  ) : (
    <FastField component={DatePickerWrapper} {...props} />
  );
}
